import { useRef, FormEvent } from "react";
import { useNavigate } from "react-router-dom";
import { useUploadCSV } from "../../services/useTransactions";

export default function UploadCSVPage() {
  const inputRef = useRef<HTMLInputElement>(null);
  const uploadMutation = useUploadCSV();
  const nav = useNavigate();

  async function handleSubmit(e: FormEvent) {
    e.preventDefault();
    const file = inputRef.current?.files?.[0];
    if (!file) return alert("Selecione um arquivo CSV");
    try {
      await uploadMutation.mutateAsync(file);
      nav("/finance/reconcile");
    } catch (err) {
      alert((err as Error).message);
    }
  }

  return (
    <div className="p-8">
      <h1 className="text-2xl font-bold mb-4">Importar Extrato CSV</h1>
      <form onSubmit={handleSubmit} className="space-y-4">
        <input type="file" accept=".csv" ref={inputRef} />
        <button
          type="submit"
          className="px-4 py-2 bg-green-600 text-white rounded"
        >
          {uploadMutation.isLoading ? "Enviando..." : "Enviar"}
        </button>
      </form>
      {uploadMutation.error && (
        <p className="text-red-500">{uploadMutation.error.message}</p>
      )}
    </div>
  );
}
